// ========== Start Featured Testimonials Slider ==========
var slider = new KeenSlider("#testimonials__slider", {
  loop: true,
}, 
[
  navigation,
  (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout)
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 10000)
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  },
])
// ========== End Featured Testimonials Slider ==========


// Prevent layout shifting
// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll('.featured-testimonials .keen-slider__slide').forEach(el => el.style.display = 'block');
// })